<template>
    <div class="modal fade rating_modal" id="modalHistory" tabindex="-1" role="dialog" aria-labelledby="rating_modal">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h3 class="modal-title" id="rating_modal">{{$store.getters.t('pet_and_project_create_history_new_history')}}</h3>
                </div>
                <!-- end /.modal-header -->
                <div class="modal-body">
                    <div>
                        <label for="title_field">{{$store.getters.t('pet_and_project_create_history_title')}}</label>
                        <input type="text" v-model="$v.historyForm.title.$model" id="title_field" class="text_field pt-0 pb-0" :placeholder="$store.getters.t('pet_and_project_create_history_enter_title')">
                        <div class="field-error-text" v-if="$v.historyForm.title.$error">{{$store.getters.t('pet_and_project_create_history_title_required')}}</div>
                    </div>
                    <div class="rating_field mt-3 mb-3">
                        <label for="comment_field">{{$store.getters.t('pet_and_project_create_history_please_tell_story')}}</label>
                        <textarea name="rating_field" v-model="$v.historyForm.comment.$model" id="comment_field" class="text_field" :placeholder="$store.getters.t('pet_and_project_create_history_enter_story')"></textarea>
                        <div class="field-error-text" v-if="$v.historyForm.comment.$error">{{$store.getters.t('pet_and_project_create_history_story_required')}}</div>
                    </div>

                    <!-- end /.form -->

                    <div class="form-group">
                        <div class="upload_wrapper mb-3">
                            <div class="row text-center">
                                <div class="col-12 col-md-6">
                                    <p>{{$store.getters.t('pet_and_project_create_history_attach_photos')}}</p>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="custom_upload">
                                        <label for="screenshot">
                                            <input type="file" id="screenshot" name="photos" class="files w-100" accept=".png,.jpeg,.jpg,.gif" @change="addImages" multiple>
                                            <span class="btn btn--round btn--sm">{{$store.getters.t('pet_and_project_create_history_choose_photos')}}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <template v-for="(image, index) in previewImages">
                            <div class="row mt-4">
                                <div class="col-3">
                                    <img :src="image.base64" alt="" class="w-100">
                                </div>
                                <div class="col-7" style="word-break: break-word;">
                                    {{ image.name }}
                                </div>
                                <div class="col-2 text-right">
                                    <span class="lnr upload_cross lnr-cross" style="cursor:pointer;" @click="deletePhoto(index)"></span>
                                </div>
                            </div>
                        </template>
                    </div>

                    <div class="row">
                        <div class="col-md-12" v-if="historyRequestStatus === 'failed'">
                            <button class="btn btn--round btn--danger w-100 success-result" data-dismiss="modal">{{$store.getters.t('pet_and_project_create_history_error_try_later')}}</button>
                        </div>
                        <div class="col-md-12" v-if="historyRequestStatus === 'pending'">
                            <button class="btn btn--round btn--default w-100">{{$store.getters.t('pet_and_project_create_history_sending')}}</button>
                        </div>
                        <div class="col-md-12" v-if="historyRequestStatus === 'success'">
                            <button class="btn btn--round btn--success w-100 success-result" data-dismiss="modal">{{$store.getters.t('pet_and_project_create_history_success')}}</button>
                        </div>
                        <div class="col-md-6" v-if="historyRequestStatus === 'waiting_to_send'">
                            <button class="btn btn--round btn--default w-100" @click="submitHistoryForm">{{$store.getters.t('pet_and_project_create_history_send')}}</button>
                        </div>
                        <div class="col-md-6 mt-2 mt-md-0" v-if="historyRequestStatus === 'waiting_to_send'">
                            <button class="btn btn--round btn--default w-100" data-dismiss="modal">{{$store.getters.t('pet_and_project_create_history_close')}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions} from 'vuex'
import {required, numeric, email, minValue} from 'vuelidate/lib/validators';

export default {
    name: "PetAndProjectCreateHistory",
    props: ['object','type'],
    data(){
        return{
            historyRequestStatus: 'waiting_to_send',

            previewImagesOnlyBase64: [],
            previewImages: [],
            images: [],
            historyForm: {
                comment: null,
                title: null,
                images: [],
            },
        }
    },

    mounted(){
        this.historyRequestStatus = 'waiting_to_send';

        $('#modalHistory').on('hidden.bs.modal', function(){

            $('body').css({'padding-right': '0'});

            if( $('.modal-backdrop').length ){
                $('.modal-backdrop').each(function(){
                    $(this).remove();
                })
            }

        });

    },

    methods:{
        ...mapActions(['getHistories']),

        submitHistoryForm() {
            let self = this;
            let endpoint = '/api/histories';

            self.$v.$touch();
            if (self.$v.historyForm.$invalid) {
                return false;
            }

            self.historyRequestStatus = 'pending';
            let data = new FormData();
            data.append('description', self.historyForm.comment);
            data.append('pet_id', (self.type === 'pet' ? this.object.id : ''));
            data.append('project_id', (self.type === 'project' ? this.object.id : ''));
            data.append('title', self.historyForm.title);

            self.previewImagesOnlyBase64.forEach(function (base64) {
                let block = base64.split(";");
                let contentType = block[0].split(":")[1];
                let realData = block[1].split(",")[1];
                let blob = self.b64toBlob(realData, contentType);
                data.append('images[]', blob)
            });

            axios.post(endpoint, data, {
                header: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(response => {
                    response = response.data;

                    if (response.success) {
                        self.historyRequestStatus = 'success';

                        setTimeout(function (){
                            $('#modalHistory').modal('hide');

                            self.$v.$reset();
                            self.historyForm = {
                                comment: null,
                                title: null,
                                images: [],
                            };

                            self.previewImagesOnlyBase64 = [];
                            self.previewImages = [];
                            self.historyRequestStatus = 'waiting_to_send';

                            self.$emit('update-events')

                        }, 1000)
                    }
                })
                .catch((error) => {
                    error = error.response.data

                    if(!error.success){
                        self.historyRequestStatus = 'failed';

                        setTimeout(function () {
                            self.historyRequestStatus = 'waiting_to_send';
                            console.log(error)
                        }, 3000);
                    }
                })
                .then(() => {
                    this.getHistories({targetId: this.object.id, type: this.type})
                })
        },
        deletePhoto(index) {
            let self = this;
            self.noReloadPreview = true;
            self.previewImages.splice(index, 1);
            self.images.splice(index, 1);
            self.historyForm.images.splice(index, 1);
            self.previewImagesOnlyBase64.splice(index, 1);
        },
        addImages(e) {
            let self = this;
            let files = e.target.files;
            self.images = [];

            for (let key in files) {
                if (e.target.files[key] instanceof File) {
                    self.images.push(e.target.files[key]);
                }
            }
        },
        b64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;

            let byteCharacters = atob(b64Data);
            let byteArrays = [];

            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                let slice = byteCharacters.slice(offset, offset + sliceSize);

                let byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                let byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
            }

            return new Blob(byteArrays, {type: contentType});
        },
    },
    watch: {
        images() {
            let self = this;

            if (self.noReloadPreview) {
                self.noReloadPreview = false;
                return false
            }

            self.images.forEach(function (image) {
                if (typeof FileReader === "function") {
                    const reader = new FileReader();

                    reader.onload = event => {
                        if ($.inArray(event.target.result, self.previewImagesOnlyBase64) === -1) {
                            self.previewImages.push({
                                'base64': event.target.result,
                                'name': image.name,
                            });
                            self.previewImagesOnlyBase64.push(event.target.result);
                            self.historyForm.images.push(image);
                        }
                    };

                    reader.readAsDataURL(image);
                }
            });
        }
    },
    validations: {
        historyForm: {
            title: {
                required
            },
            comment: {
                required
            },
        },
    },

}
</script>

<style scoped>

</style>
